// extracted by mini-css-extract-plugin
export var disabled = "_1b-5";
export var error = "_1b-1";
export var fitContent = "_1b-6";
export var hasSuffix = "_1b-4";
export var iconWrapper = "_1b-b";
export var infoIconWrapper = "_1b-d _1b-b";
export var input = "_1b-a";
export var inputWrapper = "_1b-0";
export var large = "_1b-8";
export var leadingIconWrapper = "_1b-c _1b-b";
export var measureBox = "_1b-e";
export var medium = "_1b-7";
export var readonly = "_1b-2";
export var small = "_1b-3";
export var suffix = "_1b-9";